import axios from "axios";
import { authorizedHeader } from "./authorization";
import {
  vehicleDetailsApiUrl,
  vehicleHealthStatusUrl,
} from "components/Common/endpoints";

export const getVehicleDetails = async (vIdVal) => {
  const response = await axios({
    method: "GET",
    url: vehicleDetailsApiUrl,
    params: {
      vIdVal,
    },
    headers: authorizedHeader(),
  });
  return response?.data;
};

export const getVehicleHealthStatus = async (vIdVal) => {
  const response = await axios({
    method: "GET",
    url: vehicleHealthStatusUrl,
    params: {
      vIdVal,
    },
    headers: authorizedHeader(),
  });
  return response?.data;
};
